import { createFileRoute, redirect } from '@tanstack/react-router'

import { z } from 'zod'

import { Subtitle, Title } from '@/shared/auth/components/common/card'
import { AuthErrorComponent } from '@/shared/auth/components/common/error-component'
import { AuthPendingComponent } from '@/shared/auth/components/common/pending-component'
import { LoginForm } from '@/shared/auth/components/forms/login'

const loginSearchSchema = z.object({
	error: z.string().optional(),
})

export const Route = createFileRoute('/_auth/login')({
	validateSearch: loginSearchSchema,

	beforeLoad: ({ context: { clerk } }) => {
		if (clerk.auth?.isSignedIn) {
			throw redirect({ to: '/home' })
		}
	},

	head: () => ({
		meta: [
			{
				title: 'Login | BitLyft AIR®',
			},
		],
	}),
	component: RouteComponent,
	pendingComponent: AuthPendingComponent,
	errorComponent: AuthErrorComponent,
})

function RouteComponent() {
	const { error } = Route.useSearch()

	return (
		<>
			<Title>Log in</Title>
			<Subtitle>Sign in to access BitLyft AIR®</Subtitle>
			<LoginForm initialError={error} />
		</>
	)
}
